import Select from "../Select";
import AjaxSelect from "../AjaxSelect";
import PolygonSelector from "../draw-terr";
import Alert from "../Alert";
import { getPopupContainer } from "../../../../../../helpers/popUp";

export default function FocusArea({
  onChange = () => { },
  formValue = {},
  t = (s) => s,
  country = '',
  visible = false,
}) {
  return (
    <div className="form-group">
      {visible && (
        <Alert
          message="The focus area should be located inside the origin country. Subjects included in the focus area will be displayed in your project dashboard."
          localKey="focusAreaProject"
        />
      )}
      <Select
        {...getPopupContainer()}
        options={[
          {
            label: t('Custom Area'),
            value: 'customArea',
          },
          {
            label: t('Administrative Level'),
            value: 'administrativeLevel',
          },
        ]}
        value={formValue.typeOfArea}
        label={t('Type of Area')}
        onChange={(v) => {
          onChange('typeOfArea', v);
          onChange('area', undefined);
          onChange('administrativeLevel1', undefined);
          onChange('administrativeLevel2', undefined);
        }}
      />

      {formValue.typeOfArea === 'administrativeLevel' && (
        <>
          <AjaxSelect
            props={{
              placeholder: [
                "Province"
              ],
            }}
            label={t('Province')}
            formsValue={formValue}
            call={`AdministrativeLevel::getOptions({\n      \"country\": \"country\",\n      \"level\": \"level_1 as \"\n    })::{\n      \"label\": \"name\",\n      \"value\": \"id\"\n    }`}
            value={formValue.administrativeLevel1}
            onChange={(v) => {
              onChange('administrativeLevel1', v)
              onChange('administrativeLevel2', undefined)
            }}
            allowClear
          />

          {!!formValue.administrativeLevel1 && (
            <AjaxSelect
              label={t('Territory')}
              props={{
                placeholder: [
                  "Territory"
                ],
              }}
              formsValue={formValue}
              call={`AdministrativeLevel::getOptions({\n      \"country\": \"country\",\n      \"administrativeLevel1\": \"administrativeLevel1\",\n      \"level\": \"level_2 as \"\n    })::{\n      \"label\": \"name\",\n      \"value\": \"id\"\n    }`}
              value={formValue.administrativeLevel2}
              onChange={(v) => onChange('administrativeLevel2', v)}
              allowClear
            />
          )}
        </>
      )}

      {formValue.typeOfArea === 'customArea' && (
        <PolygonSelector
          country={country}
          value={formValue.area}
          onChange={(val) => onChange('area', val)}
          canEdit={true}
          label={t('Draw Territory')}
        />
      )}

    </div>
  );
}
